import { EntityNotesTableModal } from "components/entityNotesTableModal";
import {
  useFetchLawsuitAuditLogsQuery,
  useUpdateLawsuitAuditLogMutation,
  useDeleteLawsuitAuditLogMutation,
  useCreateLawsuitAuditLogMutation,
} from "features/legal/legalAPI";
import { useParams } from "react-router-dom";

function LawsuitAuditLogsModal({ title, open, lawsuit, onCancel }) {
  const { debtorId } = useParams();

  const { data: auditLogs = [], isLoading } = useFetchLawsuitAuditLogsQuery(
    { debtorId, lawsuitId: lawsuit?.id },
    { skip: !lawsuit?.id },
  );

  const [createAuditLog, { isLoading: isCreating }] = useCreateLawsuitAuditLogMutation();
  const [updateAuditLog, { isLoading: isUpdating }] = useUpdateLawsuitAuditLogMutation();
  const [deleteAuditLog] = useDeleteLawsuitAuditLogMutation();

  return (
    <EntityNotesTableModal
      title={title}
      open={open}
      onCancel={onCancel}
      entityName="Lawsuit"
      notes={auditLogs}
      isLoading={isLoading}
      onCreateNote={({ message }) =>
        createAuditLog({
          debtorId,
          lawsuitId: lawsuit.id,
          message,
        })
      }
      onUpdateNote={({ noteId, message }) =>
        updateAuditLog({
          debtorId,
          lawsuitId: lawsuit.id,
          auditLogId: noteId,
          message,
        })
      }
      onDeleteNote={(noteId) =>
        deleteAuditLog({
          debtorId,
          lawsuitId: lawsuit.id,
          auditLogId: noteId,
        })
      }
      isCreating={isCreating}
      isUpdating={isUpdating}
    />
  );
}

export default LawsuitAuditLogsModal;
